import { render } from "./confirmDialog.vue?vue&type=template&id=3670bdb3"
import script from "./confirmDialog.vue?vue&type=script&lang=js"
export * from "./confirmDialog.vue?vue&type=script&lang=js"

import "./confirmDialog.vue?vue&type=style&index=0&id=3670bdb3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__